module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.49e60e31.png";